import React from 'react'
import styled from 'styled-components';
import UserInfoItem from './UserInfoItem'
import PriceBox from './PriceBox'
import ViewBtn from '../common/ViewBtn'

const PieceStyle = styled.div`
  background: #FFFFFF;
  box-shadow: 8px 8px 23px -4px rgba(13, 64, 152, 0.16);
  border-radius: 16px;
  width: 330px;
  margin: 0 20px 20px 0;
  &:hover {
    box-shadow: 8px 8px 23px -4px rgba(13, 64, 152, 0.26);
  }
  .cover {
    height: 240px;
    background-color: #ccc;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    display: block;
  }
  >.cont {
    padding: 15px;
    .h3 {
      color: #2A2D35;
      margin-bottom: 20px;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
    >.m20 {
      margin: 20px 0;
    }
    >.buy-btn {
      font-size: 18px;
    }
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export default function ListBoxPiece() {
  return (
    <PieceStyle>
      <img className="cover" src="" alt=""/>
      <div className="cont">
        <h3 className="h3">Metamorphose Metamorphose Metamorphose</h3>
        <UserInfoItem size="sm">owocki</UserInfoItem>
        <div className="m20">
          <PriceBox size="sm">3</PriceBox>
        </div>
        <div className="buy-btn">
          <ViewBtn>Buy Now</ViewBtn>
        </div>
      </div>
    </PieceStyle>
  )
}
